// extracted by mini-css-extract-plugin
export default {"errorBoundary":"error-boundary__errorBoundary___QBBxO","errorText":"error-boundary__errorText___nJDlw","errorDetails":"error-boundary__errorDetails___JhFxY"};